/* BG lander helpers (unit 50c, GemPages libido landers). Loaded by bg-lp-c-stack / bg-lp-c-faq; runs once per page.
   1. [data-bg-lp-c-scroll="shop|learn"] buttons (live "bio-hero-actions" / "bio-podlife-shop"):
      shop  -> buy box not opened yet: bring the "Next Step" button to the bottom of the screen;
               opened: bring "1. Select Size" to the top.
      learn -> bring "Next Step" (or "1. Select Size" once opened) to the top.
   2. Offer bar reveal: NOT here — the single shared script bg-lp-d-offer-reveal.js (loaded by layout/theme.liquid on every
      GemPages blank lander, body[data-bg-offer="deferred"]) watches this unit's [data-bg-offer-reveal] targets.
   3. FAQ (bg-lp-c-faq): clicking an open answer closes it (live behaviour). */
(() => {
  if (window.bgLpCLander) return;
  window.bgLpCLander = true;

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const viewportHeight = () => (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  const viewportTop = () => (window.visualViewport && window.visualViewport.offsetTop) || 0;
  const offerOffset = () => {
    const bar = document.querySelector('.bg-offer-bar');
    const revealed = document.body.dataset.bgOffer !== 'deferred' || document.body.hasAttribute('data-bg-offer-revealed');
    return bar && revealed ? bar.offsetHeight : 0;
  };

  const scrollToY = (top) => window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion() ? 'auto' : 'smooth' });

  const scrollToTarget = (target, placement) => {
    const rect = target.getBoundingClientRect();
    if (placement === 'bottom') {
      const cushion = Math.max(10, Math.min(18, Math.round(viewportHeight() * 0.016)));
      scrollToY(rect.bottom + window.scrollY - viewportHeight() - viewportTop() + cushion);
    } else {
      scrollToY(rect.top + window.scrollY - 12 - offerOffset());
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bg-lp-c-scroll]');
    if (button) {
      const box = document.querySelector('bg-lp-c-buy-box');
      if (!box) return;
      event.preventDefault();
      const opened = box.isRevealed();
      if (button.dataset.bgLpCScroll === 'learn') {
        scrollToTarget(opened ? box.sizeTarget() : box.nextTarget(), 'top');
      } else if (opened) {
        scrollToTarget(box.sizeTarget(), 'top');
      } else {
        scrollToTarget(box.nextTarget(), 'bottom');
      }
      return;
    }

    const answer = event.target.closest('[data-bg-lp-c-faq-close]');
    if (answer) {
      const details = answer.closest('details');
      if (details && details.open) details.open = false;
    }
  });
})();
